module.exports = __webpack_public_path__ + "scripts/brand-icons.ttf?b7d071b9";


//////////////////
// WEBPACK FOOTER
// ./semantic/dist/themes/default/assets/fonts/brand-icons.ttf
// module id = 220
// module chunks = 1